var Diagnostic_Header = {
    init:function(){
        $(window).scroll(function(){
            Diagnostic_Header.scroll();
        });
        Diagnostic_Header.scroll();

        $(".sommaire-diagnostic-akrolab .btn-routine").on("click touchend", function(e){
            e.stopPropagation();
            e.preventDefault();

            if(e.type == "touchend"){
                $(this).off("click");
            }

            var _hdest = $("#prescription_visage").offset().top - $(".sommaire-diagnostic-akrolab").outerHeight();
            console.log("Click btn : " + _hdest);
            $("html, body").animate({scrollTop:_hdest}, 10);
        })


    },
    scroll:function(){

        if($(window).scrollTop()>=100){
            $(".sommaire-diagnostic-akrolab").addClass("visible");
            $("#shopify-section-announcement, #shopify-section-navigation--logo-center").addClass("masked");
        }else{
            $(".sommaire-diagnostic-akrolab").removeClass("visible");
            $("#shopify-section-announcement, #shopify-section-navigation--logo-center").removeClass("masked");
        }
    }
}

$(window).on("load", function(){
    if($(".sommaire-diagnostic-akrolab").length){
        Diagnostic_Header.init();
    }
})